<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $tc("customer", 2) }}</div>
      <!-- <router-link
        v-if="cinema_manager_add_edit_disabled != 3"
        class="btn-blue"
        to="add-Customers"
        >{{ $t("add") }}</router-link
      > -->
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex align-item-center justify-content-center" style="gap:15px;">
        <b-form-input
          v-debounce:500="clearSearch"
          v-model="searchValue"
          :placeholder="$tc('searchs')"
        ></b-form-input>
        <div @click="resetList" class="btn btn-secondary d-flex align-item-center justify-content-center">
          Search
        </div>
      </div>
      <div class="d-flex"></div>
      <b-dropdown
        :text="filter_is_active_label"
        variant="dropdown-curve"
        class="ml-auto mr-3 filter-status-dropdown"
      >
        <b-dropdown-item @click="onChangeFilterIsActive('')"
          >All User</b-dropdown-item
        >
        <b-dropdown-item @click="onChangeFilterIsActive('N')"
          >Customer List</b-dropdown-item
        >
        <b-dropdown-item @click="onChangeFilterIsActive('Y')"
          >Guest List</b-dropdown-item
        >
      </b-dropdown>
      <!-- <b-dropdown
        :text="is_transaction_filter_label"
        variant="dropdown-curve"
        class=" mr-3 filter-status-dropdown"
        style="width:200px"
      >
        <b-dropdown-item @click="onChangeFilterIsActiveOnlyTransaction('')"
          >All Transaction</b-dropdown-item
        >
        <b-dropdown-item @click="onChangeFilterIsActiveOnlyTransaction(1)"
          >With Transaction</b-dropdown-item
        >
        <b-dropdown-item @click="onChangeFilterIsActiveOnlyTransaction(2)"
          >Without Transaction</b-dropdown-item
        >
      </b-dropdown> -->

      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown
          :onSelect="filterIsActive => getCustomersList(filterIsActive)"
        /> -->
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t("of") }}&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

        <div class="d-flex align-items-center" style="float:right">
            Download as:
           <a  @click="excelDownload(BASE_URL)" title="Download as Excel">
          <img class="mx-1"  src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
        </div>
    </div>
<!---Excel Export Start-->
    <div >
      <table class="list-view-table d-none" ref="exportable_table">
        <thead>
          <tr>
            <th>
              <!-- <img
                v-if="this.columnName != 'first_name'"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('first_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              /> -->
              {{ $tc("customer", 1) }}
            </th>
            <th class="text-center">{{ $t("mobileno") }}</th>
            <th class="text-center">{{ $t("email") }}</th>
            <th class="text-center">{{ $t("is Guest User") }}</th>
            <!-- <th class="text-center">{{ $t("No of Transaction") }}</th> -->

            <th class="text-right">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
          </tr>
        </thead>
        <tbody v-if="customerCopy.length > 0">
          <tr
            v-for="(customer, customerIndex) in customerCopy"
            :key="customerIndex"
          >
            <td class="text-left ml-auto">
              <div>{{ customer.first_name }}&nbsp;{{ customer.last_name == '-' ? '' : customer.last_name }}</div>
            </td>
            <td class="text-center">{{ customer.cust_mobile }}</td>
            <td class="text-center">{{ customer.cust_email || "-" }}</td>
            <td class="text-center">
              <div class="">{{ customer.is_guest_user || "-" }}</div>
            </td>
            <!-- <td class="text-right">{{ customer.no_of_transaction }}</td> -->
            <td>
            <!-- {{customer.cust_is_active ? 'Active' : 'Inactive'}} -->
            Active
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <!-- <label class="ios-switch">
                  <input
                    :checked="customer.cust_is_active == 'Y'"
                    disabled
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label> -->
                <!-- <StatusDot :status="'active'" />

                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="customer.is_guest_user == 'N'"
                    v-on:click="onEditCustomer(customer)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="onViewCustomer(customer)"
                    v-if="customer.is_guest_user == 'N'"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="goToFlow(customer.cust_id)"
                    v-if="customer.is_guest_user == 'N'"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("userJourneyFlow") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="gotoNewTransaction(customer)">
                    <span class="icon-eye"></span>
                    View Transactions
                  </b-dropdown-item>
                </b-dropdown> -->
              </div>
            </td>
          </tr>
        </tbody>

      </table>

    </div>

    <!---Excel Export End-->

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th>
              <!-- <img
                v-if="this.columnName != 'first_name'"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('first_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              /> -->
              {{ $tc("customer", 1) }}
            </th>
            <th class="text-center">{{ $t("mobileno") }}</th>
            <th class="text-center">{{ $t("email") }}</th>
            <th class="text-center">{{ $t("is Guest User") }}</th>
            <!-- <th class="text-center">{{ $t("No of Transaction") }}</th> -->

            <th class="text-right">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
          </tr>
        </thead>
        <tbody v-if="customers.length > 0">
          <tr
            v-for="(customer, customerIndex) in customers"
            :key="customerIndex"
          >
            <td class="text-left ml-auto">
              <div>{{ customer.first_name }}&nbsp;{{ customer.last_name == '-' ? '' : customer.last_name }}</div>
            </td>
            <td class="text-center">{{ customer.cust_mobile }}</td>
            <td class="text-center">{{ customer.cust_email || "-" }}</td>
            <td class="text-center">
              <div class="">{{ customer.is_guest_user || "-" }}</div>
            </td>
            <!-- <td class="text-right">{{ customer.no_of_transaction }}</td> -->
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <!-- <label class="ios-switch">
                  <input
                    :checked="customer.cust_is_active == 'Y'"
                    disabled
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label> -->
                <StatusDot :status="'active'" />

                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="customer.is_guest_user == 'N'"
                    v-on:click="onEditCustomer(customer)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="onViewCustomer(customer)"
                    v-if="customer.is_guest_user == 'N'"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="goToFlow(customer.cust_id)"
                    v-if="customer.is_guest_user == 'N'"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("userJourneyFlow") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="gotoNewTransaction(customer)">
                    <span class="icon-eye"></span>
                    View Transactions
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="4">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="customers.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import * as XLSX from "xlsx";
import {createQueryString} from "@/services/ApiHelper";
import { BASEURL } from "@/config/index";
import { CLIENT_NAME } from "@/helper/Role";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      // card_id: "",
      // card_type: "",
      // bank_id: "",

      // bank_name: "",
      guestcustomers: [],
      customers: [],
      customerCopy: [],
      filter_is_active_label: "All User",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      guestRows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        // { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      listType: "",
      filterType: 1,
      is_transaction_filter: "",
      is_transaction_filter_label: "All Transaction"
    };
  },
  beforeMount() {
    this.cinema_manager_add_edit_disabled = this.secureStore.get(
      "USINFO"
    ).role_id;
    this.getCustomersList();
    // this.onViewOffer();
    // this.onEditInstitute();
  },
  methods: {
    clearSearch(event) {
      if(!this.searchValue) {
        this.getCustomersList();
      }
    },
    excelDownload(BASE_URL) {
      try{
      let payload = {
        searchValue: this.searchValue,
        user_type: this.listType,
        transaction_type: this.is_transaction_filter,
        filter_is_active: 'Y',
        orderby: this.orderby
      };
      let qs = createQueryString(payload);
      window.open(`${BASE_URL}/api/marketing/view-guest-customers-excel${qs}`)
      } catch(err) {
        console.log('Error:', err);
      }

    },
      ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "Customer" });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn || "Customer." + (type || "xlsx")
          );
    },
    resetList() {
      // let loader = this.$loading.show();
      this.isSort = false;
      this.isAscending = true;
      this.isAscending = true;
      this.orderby = "";
      this.columnName = "";
      this.currentPage = 1;
      // this.showCustomers();
      this.getCustomersList();
      // setTimeout(() => loader.hide(), 100);
    },
    showCustomers() {
      let endVal = this.perPage;
      let startVal = this.currentPage;
      if (this.currentPage > 1) {
        startVal = this.perPage * (this.currentPage - 1);
      } else {
        startVal = 0;
      }
      endVal = startVal + this.perPage;
      console.log(startVal, endVal, this.customerCopy.length, this.listType);
      let tempVal = [...this.customerCopy];

      if (this.searchValue) {
        let loader = this.$loading.show();
        let search_value = this.searchValue.toLowerCase();
        tempVal = tempVal.filter(x => {
          let cust_name = x.cust_name
            ? x.cust_name.toLowerCase().includes(search_value)
            : false;
          let cust_email = x.cust_email
            ? x.cust_email.toLowerCase().includes(search_value)
            : false;
          let cust_mobile = x.cust_mobile
            ? x.cust_mobile.toLowerCase().includes(search_value)
            : false;
          let checkCustomer = this.listType
            ? x.is_guest_user.toLowerCase() == this.listType.toLowerCase()
            : true;
          let is_transaction =
            this.is_transaction_filter == 1
              ? x.no_of_transaction > 0
              : this.is_transaction_filter == 2
              ? x.no_of_transaction == 0
              : true;
          console.log(x.is_guest_user, this.listType, checkCustomer);
          setTimeout(() => loader.hide(), 100);
          return (
            (cust_name || cust_email || cust_mobile) &&
            (checkCustomer && is_transaction)
          );
        });
      } else if (this.listType) {
        let loader = this.$loading.show();

        tempVal = tempVal.filter(x => {
          let checkCustomer = this.listType
            ? x.is_guest_user.toLowerCase() == this.listType.toLowerCase()
            : true;
          let is_transaction =
            this.is_transaction_filter == 1
              ? x.no_of_transaction > 0
              : this.is_transaction_filter == 2
              ? x.no_of_transaction == 0
              : true;
          loader.hide();
          return checkCustomer && is_transaction;
        });
      } else if (this.is_transaction_filter) {
        let loader = this.$loading.show();
        tempVal = tempVal.filter(x => {
          let is_transaction =
            this.is_transaction_filter == 1
              ? x.no_of_transaction > 0
              : this.is_transaction_filter == 2
              ? x.no_of_transaction == 0
              : true;
          loader.hide();
          return is_transaction;
        });
      }
      if (tempVal.length > 0) {
        if (tempVal.length >= this.perPage) {
          this.selectedvalue = this.perPage;
        } else {
          this.selectedvalue = tempVal.length;
        }
        this.rows = tempVal.length;
        let showMovies_data = _(tempVal)
          // .orderBy(['Name'], ['asc']) // sort by ascendind
          .drop(startVal) // page in drop function starts from 0
          .take(this.perPage) // limit 2
          .value();
        // var showMovies_data=tempVal.splice(startVal,endVal)
        this.customers = showMovies_data;
      } else {
        this.customers = [];
        this.selectedvalue = 0;
        this.rows = 0;
      }
    },

    onChangeFilterIsActive(type) {
      this.listType = type;
      if (type == "Y") {
        this.filter_is_active_label = "Guest List";
      } else if (type == "N") {
        this.filter_is_active_label = "Customer List";
      } else {
        this.filter_is_active_label = "All User";
      }

      this.resetList();
    },
    onChangeFilterIsActiveOnlyTransaction(type) {
      this.is_transaction_filter = type;
      if (type == 1) {
        this.is_transaction_filter_label = "With Transaction";
      } else if (type == 2) {
        this.is_transaction_filter_label = "Without Transaction";
      } else {
        this.is_transaction_filter_label = "All Transaction";
      }

      this.resetList();
    },
    gotoNewTransaction(customer) {
      if (customer.is_guest_user == "N") {
        this.goToTransaction(customer.cust_id);
      } else {
        this.goToTransactionGuest(customer.cust_id);
      }
    },
    goToTransaction(cust_id) {
      this.$router.push({
        path: "/cinema-manager/view-customer-transaction",
        query: { cust_id: cust_id }
      });
    },
    goToTransactionGuest(guest_id) {
      this.$router.push({
        path: "/cinema-manager/view-guest-transaction",
        query: { guest_id }
      });
    },
    //Sort

    getCustomersList: function() {
      let loader = this.$loading.show();
        this.customers = [];
        MarketingService.getAllCustomerGuestList(
          this.perPage,
          this.currentPage,
          this.columnName,
          this.orderby,
          this.searchValue,
          'Y',
          this.listType,
          this.is_transaction_filter
        ).then(response => {
          // console.log("response :", response);
          const { data } = response;
          console.log("data", data);
          // console.log("data.Records :", data.Records);
          if(data && data.hasOwnProperty('totalRows') && this.currentPage == 1) {
            this.rows = data.totalRows;
             if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          }
          if (data && data.Records.length > 0) {
            // this.customers = data.Records;
            this.customers = data.Records
            this.customerCopy = data.Records;
            // console.log("this.offername :", this.offername);
            // this.rows = data.totalRows;
          }
          // this.showCustomers();
          // setTimeout(() => loader.hide(), 100);
        }).catch((err) => {
          console.log('Error', err);
        }).finally(() => {
          loader.hide();
        })
      
    },
    onViewCustomer: function(customer) {
      this.$router.push({
        path: "/marketing/view-Customers",
        query: { cust_id: customer.cust_id }
      });
      // console.log("institute_id ++++++++ :", offer);
    },
    onEditCustomer: function(customer) {
      this.$router.push({
        path: "/marketing/edit-Customers",
        query: { cust_id: customer.cust_id }
      });
      // console.log("bank_id :", bank.bank_id);
    },
    goToFlow(cust_id) {
      this.$router.push({
        name: "View User Journey Flow",
        params: { cust_id: cust_id }
      });
    },

    onChangePagination: function(event) {
      // let loader = this.$loading.show();

      if (event === undefined) {
        this.currentPage = 1;
        this.getCustomersList();
        // setTimeout(() => loader.hide(), 100);
      } else {
        this.currentPage = event;
        this.getCustomersList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.resetList();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.resetList();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CustomersComponents/customers.vue